import axios from "axios";
import * as Sentry from "@sentry/nextjs";

const axiosInstance = axios.create();

axiosInstance.CancelToken = axios.CancelToken;
axiosInstance.isCancel = axios.isCancel;

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error.response.status;
      Sentry.captureException(error, {
        tags: {
          type: status >= 500 ? "api_500_error" : "api_400_error",
          status,
          url: error.config?.url,
          method: error.config?.method,
        },
      });
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
